import React, { useEffect, useState } from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid/models/params/gridCellParams';
import Checkbox from '@mui/material/Checkbox';
import { useStringsContext } from '../../../../contexts/strings';
import { useSnackbar } from 'notistack';
import { AuthContextValues, useUserAuth } from '../../../../contexts/auth';
import adminApi from '../../../../api/admin-api';

interface Props {
  params: GridRenderCellParams;
  currentUser: AuthContextValues;
}

const ToggleSuperadminRow = ({ params, currentUser }: Props) => {
  const { strings } = useStringsContext();
  const { enqueueSnackbar } = useSnackbar();
  const { uid } = params.row;
  const [isChecked, setIsChecked] = useState(params.value);
  const [submittingSuperadmin, setSubmittingSuperadmin] = useState(false);
  const { currentUser: userAuth } = useUserAuth();

  useEffect(() => {
    setIsChecked(params.value);
  }, [params.value]);

  const handleChange = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    onToggleSuperadmin(uid, checked);
  };

  const onToggleSuperadmin = async (userId: string, checked: boolean) => {
    setSubmittingSuperadmin(true);

    try {
      const response = await adminApi.post({
        path: `/users/toggle-backend-superadmin`,
        auth: await userAuth?.getIdToken(),
        body: { userId },
      });
      const responseData = await response.json();
      if (
        responseData.error ||
        responseData.userId !== userId ||
        responseData.superadmin !== checked
      ) {
        throw new Error();
      }
      enqueueSnackbar(strings.messages.saveSuccess, { variant: 'success' });
      setIsChecked(responseData.superadmin);
    } catch (error) {
      enqueueSnackbar(strings.messages.saveError, { variant: 'error' });
    } finally {
      setSubmittingSuperadmin(false);
    }
  };

  return (
    <Checkbox
      checked={isChecked}
      onChange={handleChange}
      disabled={submittingSuperadmin || !currentUser.isSuperAdmin}
    />
  );
};

export default ToggleSuperadminRow;
